import { MapCard } from "../MapCard/MapCard"
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web"
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web"
import { MapCarousel } from "../MapCarousel/MapCarousel"
import { formatMoney } from "@Utils/Functions"

export const InfoWindowDesktop = ({currentIndex, carouselData, closeCallback, nextPreviousCallback, onEndReached, paginatorInfo}) => {
    return (
        <div className="overlay-wrapper">
            <div className="overlay-closer__container">
                <button onClick={closeCallback} className="close-button"><CloseButton /></button>
            </div>

            <div className="overlay-wrapper__container">
                <MapCarousel
                    items={carouselData.map((item, index) => <MapCard key={`card-${item.id}-${index}`} data={item} isActive={currentIndex === index} currentIndex={currentIndex} index={index} nextPreviousCallback={nextPreviousCallback} />)}
                    itemHeight={162} //esto debería ser una variable
                    onEndReached={onEndReached}
                />
            </div>
            
            <div className="overlay-footer">
                <span className="overlay-footer__pagination">{currentIndex + 1} / {formatMoney(paginatorInfo.total)}</span>
            </div>
        </div>
    )
}